import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

interface SelectOption {
  value: string;
  label: string;
}

export default function ControlledSelect({
  name,
  label,
  options,
  multiple,
  required,
}: {
  name: string;
  label: string;
  options: SelectOption[];
  multiple?: boolean;
  required?: boolean;
}) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormControl error={!!fieldState.error}>
          <InputLabel id={`${name}-label`} required={required}>
            {label}
          </InputLabel>
          <Select
            {...field}
            labelId={`${name}-label`}
            label={label}
            multiple={multiple}
            renderValue={
              multiple
                ? (selected: string[]) =>
                    selected
                      ?.map((s) => options.find((o) => o.value === s)?.label)
                      .join(", ")
                : undefined
            }
            required={required}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {multiple && (
                  <Checkbox checked={field.value?.includes(option.value)} />
                )}
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>
            {fieldState.error ? fieldState.error.message : ""}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
}
